var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"dashboard-content"},[_c('v-container',[_c('v-row',{staticClass:"d-flex justify-center mt-12 mt-md-16"},[_c('v-col',{attrs:{"cols":"12","sm":"10","md":"8","lg":"8"}},[_c('UserWallet')],1),_c('v-col',{attrs:{"cols":"12","sm":"10","md":"8","lg":"4"}},[_c('BalanceAnalysis')],1)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }